$(document).ready(function(){
  //BO Quick add to cart on mobile
  $('.cart-quick-view').click(function(){
    $(this).addClass('hide');
    $(this).next('.quick_add_container').css({'opacity': 1,'visibility': 'visible'});
    $(this).prev('.quick-view-close').removeClass('hide');
  });
  $('.quick-view-close').click(function(){
    $(this).addClass('hide');
    $(this).next().next('.quick_add_container').css({'opacity': 0,'visibility': 'hidden'});
    $('.cart-quick-view').removeClass('hide');
  });
  //EO Quick add to cart on mobile
    $(".upselles_container").slick({
      //arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      // centerMode: true,
      // centerPadding: '40px'
     });
 $('.collection-slider-container').each(function () {
  let $container = $(this);
  let slidesToShow = $container.data('slide-show');
  let slidesToShowTab = $container.data('slide-show-tab');
  let slidesToShowMb = $container.data('slider_to_show_on_mb');

  $container.find('.collection-slider').slick({
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    draggable: true,
    nextArrow: '<div class="next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98" width="20px" height="20px"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg></div>',
    prevArrow: '<div class="prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98" width="20px" height="20px"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slidesToShowTab,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: slidesToShowMb,
          slidesToScroll: 1,
          infinite: false
        }
      }
    ]
  });
});



 $('.notification-carousel').slick( {
       autoplay:true,
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: false,
       adaptiveHeight: true, 
    }, true);   
  
var variantSubmitButtons = document.querySelectorAll('.variant-submit');


// Add click event listener to each 'variant-submit' button
   variantSubmitButtons.forEach(function(button) {
       button.addEventListener('click', function() {
     
        var selected_var = button.getAttribute('data-id');
        // console.log('selected-var',selected_var);
        var productCard = button.closest('.product');
        var addButton = productCard.querySelector('.quick_add_active .add_to_cart_button');
        addButton.setAttribute('data-id', selected_var);
        addButton.setAttribute('data-product-id', selected_var);
        addButton.click();
    });
});

  
  
  let name = $('.product-section .product .product-information .product_title').text();
  let parts = name.split('-');
  let newName = parts[0].trim();
  let encodedTitle = encodeURIComponent(newName);
   $.ajax({
        type: 'GET',
        url: 'https://levatelabel.com/search?q=' + encodedTitle + '&options%5Bprefix%5D=last&view=product-filter', 
        dataType: 'json',
        success: function(data) {
          let productsHTML = '';
           data.forEach(function(product) {
             let image = product.featured_image;
             let productTitle = product.title;
             let getColour = productTitle.split('-');

             // let getColour = productTitle.split(/-(?=[^-]*$)/);

             let wordAfterHyphen = getColour.length > 1 ? getColour[1].trim() : '';
             let classNamefirst = wordAfterHyphen.replace(/\s+/g, "-");
             let productHandle = product.handle;
             if (productTitle.includes(newName)) {
                 let productHTML = '<div class="link_with_image">';
                 productHTML += '<a href = "https://levatelabel.com/products/'+productHandle+'" class="'+classNamefirst.toLowerCase()+'" data-proTitle = "' + productTitle + '" ></a>';
                 productHTML += '</div>';
                 productsHTML += productHTML;
               }
             $('.image_product').html(productsHTML);
            });
            console.log('productsHTML', productsHTML)
            if (!name.includes("-")) {
              //$('.related_product_container').hide();
            }
            $('.link_with_image').each(function() {
            let color= $(this).find('a').attr('data-proTitle').trim();
            if (color == name.trim()) {
              $(this).addClass('matching-color');
            }
        });
        }

});

$('.product').each(function(index) {
    let nameCollection = $(this).find('h3').find('a').text().trim();
    // console.log('nameCollection', nameCollection, index)
    // let partCollection = nameCollection.split('-');
    let partCollection = nameCollection.split(/-(?=[^-]*$)/);
    let newCollectionName = partCollection[0].trim();
    let encodedTitle = encodeURIComponent(newCollectionName);
    let $imageProductCollection = $(this).find('.image_product_collection');
    console.log('encodedTitle', encodedTitle);
    $.ajax({
        type: 'GET',
        url: 'https://levatelabel.com/search?q=' + encodedTitle + '&options%5Bprefix%5D=last&view=product-filter',
        dataType: 'json',
        success: function(collectionData) {
            let productsHTML = '';
            collectionData.forEach(function(product) {
                let productTitle = product.title;
                let productHandle = product.handle;
                // let setColour = productTitle.split('-');
                let setColour = productTitle.split(/-(?=[^-]*$)/);
                // console.log('setColour', setColour, index)
                if (setColour.length == 2) {
                  let wordHyphen = setColour[1].trim();
                  // console.log(wordHyphen ,'wordHyphen');
                  let className = wordHyphen.replace(/\s+/g, "-");
                  //console.log(className);
                  // console.log('consd', productTitle, newCollectionName, nameCollection,index, setColour)
                  if (productTitle.includes(newCollectionName)) {
                      let productHTML = '<div class="link_with_image_collection">';
                      productHTML += '<a href="https://levatelabel.com/products/' + productHandle + '" data-proTitle="' + productTitle + '" class="'+className.toLowerCase()+'"></a>';
                      productHTML += '</div>';
                      productsHTML += productHTML;
                  }
                }
              // console.log(productsHTML,'productsHTML');
            $imageProductCollection.html(productsHTML);
            });
            $imageProductCollection.find('.link_with_image_collection').each(function() {
                let color = $(this).find('a').attr('data-proTitle').trim();
                let productName = $(this).closest('.product').find('h3').find('a').text().trim();
                if (color == productName) {
                    $(this).addClass('matching-color');
                }
            });
        }
    });
 });


// $(document).on('click', '.upsell-add-to-cart', function() {
   
//     var selected_var = $(this).attr('data-variant-id');
//     console.log(selected_var);
    
//     // Find the corresponding .quick_add_active .add_to_cart_button based on the position within the container
//     var addButton = $(this).closest('.upsell-data-container').find('.quick_add_active .add_to_cart_button');
    
//     console.log(addButton);
//     addButton.attr('data-id', selected_var);
//     addButton.attr('data-product-id', selected_var);
 
//     // let body = document.querySelector('.quick_add_active .add_to_cart_button');
//     // body.dispatchEvent(new Event('click'));
// });

  



  function productImage(){
          $('.product-images:not(.flickity-enabled)').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
          nextArrow: '<div class="next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98" width="20px" height="20px"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg></div>',
          prevArrow: '<div class="prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98" width="20px" height="20px"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg> </div>'
        });
  }
  
 
  if ($(window).width() < 768) {
     productImage();
  }

 $(window).resize(function() {
     if ($(window).width() < 768) {
       productImage()
     }
 })
      let h = document.querySelector('.header-scrolling-bar .scrolling-text').offsetHeight;
    console.log('height',h);
    document.documentElement.style.setProperty('--scrolling-height', h + 'px');
});


document.addEventListener('cart-drawer:close', function() {
  console.log('cart-drawer:close');
  document.body.style.overflow = 'auto'
})
document.addEventListener('cart-drawer:before-open', function() {
  console.log('cart-drawer:before-open')
  document.body.style.overflow = 'hidden'
})




  